<template lang="pug">
b-modal#miniGameTemplate(
  ref="miniGameTemplate"
  :title="$t('ui.mini_game_template')"
  centered
  no-fade
  no-close-on-backdrop
  hide-footer
  :busy="loading"
  size="lg"
  @show="reset"
  @shown="shown")
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row(v-if="item != null")
      .col-12
        .card.mb-0
          .card-header
            .row.col-12
              .form-group.col-12
                b-input-group(size="sm")
                  b-input-group-text.border-0(slot="prepend")
                    i.fas.fa-clipboard-list
                    span.ml-2  {{ item.game_type }} - {{ item.game_name }}
              .form-group.col-8
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-search
                  DebounceInput(autofocus type="text" v-model="template_code" :placeholder="$t('message.search_by_template_code')" @enter="getMiniGameTemplateList()" size="sm")

              .form-group.col-3.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getMiniGameTemplateList()"
                  variant="primary"
                  size="sm"
                )
              .form-group.col-12(v-if="isAdmin && isEditAccess")
                b-button(@click="onAdd(item.game_id)" type="button" variant="info" size="sm")
                  i.fa.fa-plus
                  span.ml-1 {{ $t("ui.combine.add_mini_game_template") }}
          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="8%")
                          span(:title="$t('ui.template_code')") {{ $t('ui.template_code') }}
                        th(width="8%")
                          span(:title="$t('ui.template_name')") {{ $t('ui.template_name') }}
                        th.text-center(width="6%")
                          span(:title="$t('ui.status')") {{ $t('ui.status') }}
                        th.text-center(width="5%" v-if="isAdmin && isEditAccess")
                          span(:title="$t('ui.action')") {{ $t('ui.action') }}
                    tbody.clusterize-content
                      tr(v-if="miniGameTemplateList.length == 0")
                        td(colspan="4").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in miniGameTemplateList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.template_code") {{ item.template_code }}
                        td
                          span(:title="item.template_name") {{ item.template_name }}
                        td.text-center
                          span
                            i(style="font-size: 14px;" :class="{'fas fa-check-circle text-success': item.status, 'fas fa-times-circle text-warning': !item.status  }")
                        td.actions.text-center.align-middle(v-if="isAdmin && isEditAccess")
                          span.mr-2
                            a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                              href="javascript:void(0)"
                              @click="onEdit(item)"
                              :title="$t('ui.edit')"
                              )
                          span
                            a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(
                              href="javascript:void(0)"
                              @click="onDelete(item)"
                              :title="$t('ui.delete')"
                              )

    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}

  addminigametemplate(ref="addMiniGameTemplate" @clicked="addMiniGameTemplate" :item="addTemplate" @failed="handleFailedColor")
  editminigametemplate(ref="editMiniGameTemplate" :item="selectedMiniGameTemplate" @clicked="afterEdit" @failed="handleFailedColor")
</template>

<script>
import config from "@/config";
import addminigametemplate from "@/components/content/miniGame/addMiniGameTemplate.vue";
import editminigametemplate from "@/components/content/miniGame/editMiniGameTemplate.vue";
import DebounceInput from "@/library/DebounceInput";
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    addminigametemplate,
    editminigametemplate,
    DebounceInput,
    SubmitButton
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      addTemplate: null,
      miniGameTemplateList: [],
      selectedMiniGameTemplate: null,
      template_code: ''
    };
  },
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_minigame");
    }
  },
  methods: {
    onAdd(e) {
      this.addTemplate = e;
      this.$refs.addMiniGameTemplate.$refs.addMiniGameTemplate.show();
    },
    onEdit(e) {
      this.selectedMiniGameTemplate = e;
      this.$refs.editMiniGameTemplate.$refs.editMiniGameTemplate.show();
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.miniGameTemplateList = [];
      this.selectedMiniGameTemplate = null;
      this.template_code = "";
    },
    shown() {
      this.getMiniGameTemplateList();
    },
    getMiniGameTemplateList() {
      let url = config.getMiniGameTemplateListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        game_id: this.item.game_id,
        template_code: this.template_code
      };
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.miniGameTemplateList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addMiniGameTemplate() {
      this.getMiniGameTemplateList();

      this.$helpers.showDialog(this.$t("ui.combine.add_mini_game_template"), this.$t("message.success"), "success");
    },
    afterEdit(item) {
      this.getMiniGameTemplateList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_mini_game_template"), this.$t("message.success"), "success");
    },
    onDelete(e) {
      this.$swal({
        title: this.$t("ui.delete"),
        text: this.$t("message.deleteOperatorMiniGameRewardUrl", { reward: e.reward_code }),
        type: "info",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          this.confirmDelete(e);
        }
      });
    },
    confirmDelete: function(e) {
      let url = config.deleteMiniGameTemplateUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        game_id: e.game_id,
        template_code: e.template_code
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getMiniGameTemplateList();
                this.$helpers.showDialog(this.$t("ui.delete"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailedColor(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
